module.exports = __webpack_public_path__ + "static/media/icon-checkbox.5a667937.svg";